import React, { Component } from 'react';
import './style/home.css';
import './style/myprogram.css';
import './style/normalize.css';
import Imagem38 from './images/Imagem 38.png';
import logo_correios_menu from './images/logo-correios-menu.png';
import anuncio from './images/anuncio.png';
import cifao from './images/cifão.png';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import {
    Redirect,
    Link
} from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import Menu from './Components/Menu';
import MyProgramStep from './Components/MyProgram/MyProgramStep';


class MyProgram extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            currBalance: 0,
            phone: 0,
            details: [],
            loading: 0
        }
    };

    componentDidMount() {

        let self = this;
        let accountDetails = JSON.parse(localStorage.getItem('accountDetails'));
        setTimeout(() => {
            try {

                self.setState({ currBalance: accountDetails.currBalance, phone: accountDetails.msisdn });
            } catch (error) {
                console.log(error)
            }
        }, 1000)


    }

    render() {
        var settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };
        /* console.log(this.props.location.state);
        if((this.props.location.state === undefined)||(this.state.redirect) ) {
            return <Redirect to={{
                pathname: "/"
            }}/>
        } */
        return (
            <div className="home program myprogram">
                <Menu currBalance={this.state.currBalance} phone={this.state.phone} />
                <div className="content-home">
                    <div className="top"></div>
                    <div className="content-main content-recharge">

                        <MyProgramStep />


                    </div>
                </div>

            </div>
        );
    }
}

export default MyProgram;
